module.exports = __webpack_public_path__ + "static/media/login-decoration-start.62f56794.svg";